module.exports = __webpack_public_path__ + "static/media/setup-hero-1-mobile.5e7486ef.jpg";